import { render, staticRenderFns } from "./ImagePoint.vue?vue&type=template&id=afb3b544&scoped=true"
import script from "./ImagePoint.vue?vue&type=script&lang=js"
export * from "./ImagePoint.vue?vue&type=script&lang=js"
import style0 from "./ImagePoint.vue?vue&type=style&index=0&id=afb3b544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb3b544",
  null
  
)

export default component.exports